var removeSubDomain = function removeSubDomain() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return url.split('.').length > 2 ? url.split('.').slice(1).join('.') : url;
};
var matchSubDomain = function matchSubDomain() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var subdomains = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _url$split$;
  return subdomains.includes((_url$split$ = url.split('//')[1]) === null || _url$split$ === void 0 ? void 0 : _url$split$.split('.')[0]);
};

// apps which should keep focus when going to other apps, ie. `app` and `beta` on all envs.
var APPS = ['app', 'app-ci', 'app-stg', 'beta', 'beta-ci', 'beta-stg'];
var sameOrigin = function sameOrigin(pathname) {
  var hostname = window.location.hostname;
  var comingFromApp = matchSubDomain("//".concat(hostname), APPS);
  var goingToApp = matchSubDomain(pathname, APPS);
  var appToApp = comingFromApp && goingToApp || !comingFromApp;
  return removeSubDomain(pathname).includes(removeSubDomain(hostname)) && appToApp;
};

// always ensure www links start with // (i.e. learn articles)
// if its a link on same domain, then remove http(s) so RR doesn't prefix with `/`
var normalisePath = function normalisePath(pathname) {
  var url = pathname.startsWith('www.') ? "//".concat(pathname) : pathname;
  return sameOrigin(pathname) ? url.replace(/https?:/, '') : url;
};
var index = function index(href) {
  var url = normalisePath(href);
  var hasFullUrl = /^(https?:\/\/|\/\/)/.test(url); // starts with 'http(s)?:' or '//'
  var isRelative = /^(\.\.?\/|\/(?!\/)|\?)/.test(url); // starts with './', '../',  single '/', or '?'
  var isAppLink = hasFullUrl ? url.split('//')[1].split('/')[0].indexOf(':') > 0 : url.split('/')[0].indexOf(':') > 0; // e.g. tel:1902 or mail:pete@clearscore.com
  var isSameOrigin = !isAppLink && sameOrigin(url);
  var isRelativeWithoutSlash = !hasFullUrl && !isAppLink; // i.e. href="results/details"
  return url && (isSameOrigin || isRelative || isRelativeWithoutSlash);
};
export default index;